import { all, takeLatest, call, put } from 'redux-saga/effects';
import actions from './actions';
import { fetchKarieUsers, fetchKarieUserInfo, fetchKarieUserAdherece, fetchKarieUserMedication, fetchKarieUserResponses, unAssignDevice } from '../../../api/karieUsers/karieUsers';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import notifications from '../notification/actions';
import _ from 'lodash'
import { default as deviceActions } from '../devices/actions'
export function* getKarieUsers() {
    const response = yield call(fetchKarieUsers, {});
    yield put({
        type: actions.GET_KARIE_USERS_SUCCESS,
        karieUsers: response.patients
    });
}

export function* getKarieUserInfo(payload) {
    try {
        const response = yield call(fetchKarieUserInfo, payload.patientId);
        if (response.info && response.info.karieUser) {
            yield put({
                type: actions.FETCH_KARIE_USER_INFO_SUCCESS,
                karieUser: response.info.karieUser,
                karieUserMedication: response.info.medication
            });
        } else {
            yield put(notifications.createNotification({
                ...response[0],
                mainAction: actions.FETCH_KARIE_USER_INFO_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_KARIE_USER_INFO_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

export function* getKarieUserAdherence(payload) {
    const response = yield call(fetchKarieUserAdherece, payload.patientId);
    yield put({
        type: actions.FETCH_KARIE_USER_ADHERENCE_SUCCESS,
        karieUserAdherence: response.karieUserAdherence
    });
}

export function* getKarieUserMedication(payload) {
    const response = yield call(fetchKarieUserMedication, payload.patientId);
    yield put({
        type: actions.FETCH_KARIE_USER_MEDICATION_SUCCESS,
        karieUserMedication: response.karieUserMedication
    });
}
export function* getKarieUserResponses(payload) {
    const response = yield call(fetchKarieUserResponses, payload.questionnaireId, payload.patientId);
    yield put({
        type: actions.FETCH_KARIE_USER_RESPONSES_SUCCESS,
        questionnaireResponses: response.responses
    });
}

export function* unassignDeviceSaga(payload) {
    try{
        const response = yield call(unAssignDevice, payload.patientId);
        if(response && Array.isArray(response) && _.includes(Object.keys(response[0]), 'code')) {
            throw response[0].message
        }
        yield put(actions.unassignDeviceSuccess());
        yield put(notifications.createNotification({
            message: "Unassigned The Device Successfully",
            status: 'SUCCESS'
        }));
        if (payload.searchOptions) {
            yield put(deviceActions.fetchDevices(payload.searchOptions));
        }
    }catch(e){
        yield put(actions.unassignDeviceFailure(e.toString()));
        yield put(notifications.createNotification({
            mainAction: actions.UN_ASSIGN_DEVICE_FAILURE,
            message: e.toString()
        }));   
    }  
}

export default function* rootSaga() {
    yield all([
        yield takeLatest(actions.GET_KARIE_USERS, getKarieUsers),
        yield takeLatest(actions.FETCH_KARIE_USER_INFO, getKarieUserInfo),
        yield takeLatest(actions.FETCH_KARIE_USER_ADHERENCE, getKarieUserAdherence),
        yield takeLatest(actions.FETCH_KARIE_USER_MEDICATION, getKarieUserMedication),
        yield takeLatest(actions.FETCH_KARIE_USER_RESPONSES, getKarieUserResponses),
        yield takeLatest(actions.UN_ASSIGN_DEVICE, unassignDeviceSaga),
    ]);
}
